import platform from 'platform';
export const getBrowserInfo = () => {
    var _a;
    const { name, os } = platform;
    const isSafari = name === 'Safari';
    const isIos = !!((_a = os === null || os === void 0 ? void 0 : os.family) === null || _a === void 0 ? void 0 : _a.includes('iOS'));
    return {
        isIos,
        isSafari,
    };
};
//# sourceMappingURL=get-browser-info.js.map